export default __webpack_public_path__ + "static/media/happyFaceV2.03015de6.svg";